module.exports = __webpack_public_path__ + "img/isa5.a2277268.png";